<template>
  <validation-observer ref="simpleRules">
    <b-form v-if="item">

      <template v-if="!item.id">
        <!-- Project Select -->
        <b-form-group
          :label="$t('Project')"
          label-for="mc-project"
        >
          <v-select
            id="vue-select-project"
            v-model="projectIdsArray"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="optionProject"
            :reduce="project => project.id"
            label="projectName"
            :placeholder="$t('Select project(s)...')"
            multiple
          />
        </b-form-group>

        <!-- Period Select -->
        <b-form-group
          :label="$t('Period')"
          label-for="mc-period"
        >
          <v-select
            id="vue-select-period"
            v-model="periodsArray"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="optionPeriod"
            :placeholder="$t('Select period(s)...')"
            multiple
          />
        </b-form-group>

        <!-- Category -->
        <b-form-group
          :label="$t('Category')"
          label-for="mc-category"
        >
          <v-select
            id="vue-select-category"
            v-model="item.requestCategory"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="optionCategory"
            :reduce="category => category.value"
            label="label"
            :placeholder="$t('Select category...')"
          />
        </b-form-group>

        <!-- Request Detail -->
        <b-form-group
          :label="$t('Request Detail')"
          label-for="mc-requestDetail"
        >
          <validation-provider
            #default="{ errors }"
            :name="$t('Request Detail')"
            rules="required"
          >
            <b-form-textarea
              v-model="item.requestDetail"
              :state="errors.length > 0 ? false : null"
              :placeholder="$t('Request detail...')"
              rows="3"
              max-rows="6"
            />
            <small class="text-danger">{{ $t(errors[0]) }}</small>
          </validation-provider>
        </b-form-group>
      </template>
      <template v-else>
        <h4>{{ $t(item.status) }}</h4>
        <b-form-group
          :label="$t('Description')"
          label-for="mc-description"
        >
          <validation-provider
            #default="{ errors }"
            :name="$t('Description')"
            rules="required"
          >
            <b-form-textarea
              v-model="item.closeDescription"
              :state="errors.length > 0 ? false : null"
              :placeholder="$t('Description...')"
              rows="3"
              max-rows="6"
            />
            <small class="text-danger">{{ $t(errors[0]) }}</small>
          </validation-provider>
        </b-form-group>
      </template>
    </b-form>
  </validation-observer>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'

import {
  BFormGroup, BForm, BFormTextarea,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BFormTextarea,
    BForm,
    vSelect,
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      defaultItem: {
        projectIdsArray: [],
        periodsArray: [],
        projectIds: null,
        periods: null,
        requestCategory: null,
        requestDetail: null,
      },
      required,
      projectIdsArray: [],
      periodsArray: [],
      optionProject: [],
      optionPeriod: [],
      optionCategory: [
        { value: 'Category 1', label: this.$t('Category 1') },
        { value: 'Category 2', label: this.$t('Category 2') },
        { value: 'Category 3', label: this.$t('Category 3') },
        { value: 'Other', label: this.$t('Other') },
      ],
    }
  },
  computed: {
    item: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        if (this.value) {
          this.$set(this, 'projectIdsArray', this.value.projectIds.split(',') || [])
          this.$set(this, 'periodsArray', this.value.periods.split(',') || [])
          return this.value
        }
        return this.defaultItem
      },
    },
  },
  async created() {
    this.getProjectOptions()
    this.getProjectPeriods()
  },
  methods: {
    getProjectOptions() {
      useJwt.axiosIns.get('project').then(response => {
        this.optionProject = response.data
      })
    },
    getProjectPeriods() {
      useJwt.axiosIns.get('project/allperiods')
        .then(response => {
          if (response.data) {
            this.optionPeriod = response.data.sort((a, b) => (a < b ? 1 : -1))
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          const postItem = JSON.parse(JSON.stringify(this.item))
          postItem.projectIds = this.projectIdsArray.join(',')
          postItem.periods = this.periodsArray.join(',')

          if (postItem.id) {
            if (postItem.status === 'Completed') {
              useJwt.axiosIns.patch('request/close', postItem)
                .then(response => {
                  if (response.data) {
                    this.$emit('submit')
                  }
                })
                .catch(e => {
                  console.log(e)
                })
            }
            if (postItem.status === 'Rejected') {
              useJwt.axiosIns.patch('request/reject', postItem)
                .then(response => {
                  if (response.data) {
                    this.$emit('submit')
                  }
                })
                .catch(e => {
                  console.log(e)
                })
            }
          } else {
            useJwt.axiosIns.post('request', postItem)
              .then(response => {
                if (response.data) {
                  this.$emit('submit')
                }
              })
              .catch(e => {
                console.log(e)
              })
          }
        }
      })
    },
  },
}
</script>
